import { useId, type Ref } from 'vue';

import type { FieldError } from '@/utils/poTracker';

// Ids that tie a field's inline error to its input (aria-describedby), unique per form instance
// since several plan forms can be open at once.
export function useFieldError(error: Ref<FieldError | null>): {
  errorId: (field: string) => string;
  describedBy: (field: string) => string | undefined;
  bad: (field: string) => string;
} {
  const uid = useId();
  const errorId = (field: string): string => `${uid}-${field}-error`;
  const describedBy = (field: string): string | undefined => (error.value?.field === field ? errorId(field) : undefined);
  const bad = (field: string): string => (error.value?.field === field ? 'border-red-400' : '');
  return { errorId, describedBy, bad };
}
